"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Group = void 0;

var Group =
/** @class */
function () {
  function Group() {}

  Group.prototype.EventGroupStatusFilterType = function () {
    return [{
      slug: 'has_invitation',
      name: 'Contacts included on the guest list',
      description: null,
      isHasInvitation: true,
      isDoesNotHaveInvitation: false
    }, {
      slug: 'does_not_have_invitation',
      name: 'Contacts absent from the guest list',
      description: null,
      isHasInvitation: false,
      isDoesNotHaveInvitation: true
    }];
  };

  return Group;
}();

exports.Group = Group;